export default "__VITE_ASSET__CNFizFu6__"